import { ComputedQuery, FiltersMap } from '@wix/bex-core';
import { MessageModalLayoutProps } from '@wix/design-system';
import { ReactElement } from 'react';

export type BulkActionToolbarRenderProp<T, F extends FiltersMap> = (props: {
  selectedValues: T[];
  uncheckedValues: T[];
  allSelected: boolean;
  openModal: () => void;
  clearSelection: () => void;
  total: number;
  openConfirmModal: (props?: Partial<MessageModalLayoutProps>) => void;
  query: ComputedQuery<F>;
}) => ReactElement;
